(function () {
  // Prevent multiple initializations
  if (window.productCardSwatchesInitialized) return;
  window.productCardSwatchesInitialized = true;

  // Get translations from window.themeVariables or use defaults
  function getTranslation(key, defaultValue) {
    if (window.themeVariables?.strings?.[key] !== undefined) {
      return window.themeVariables.strings[key];
    }
    return defaultValue;
  }

  // Get settings from window.themeVariables or use defaults
  function getSetting(key, defaultValue) {
    if (window.themeVariables?.settings?.[key] !== undefined) {
      return window.themeVariables.settings[key];
    }
    return defaultValue;
  }

  // Helper function to remove .00 and ,00 while keeping .50 and ,50
  function removeTrailingZeros(priceString) {
    return priceString.replace(/\.00(?![0-9])/g, '').replace(/,00(?![0-9])/g, '');
  }

  // Function to initialize swatches for a product card
  function initializeSwatches(productCard) {
    if (!productCard) return;

    const swatches = productCard.querySelectorAll('.product-card__color-swatches .product-card__swatch');
    if (swatches.length === 0) return;

    // Remove existing listeners by cloning (clean slate)
    swatches.forEach(swatch => {
      const newSwatch = swatch.cloneNode(true);
      swatch.parentNode.replaceChild(newSwatch, swatch);
    });

    // Get fresh references after cloning
    const freshSwatches = productCard.querySelectorAll('.product-card__color-swatches .product-card__swatch');

    // Cache for product JSON
    window.productDataCache = window.productDataCache || {};

    freshSwatches.forEach(swatch => {
      swatch.addEventListener('click', async function () {
        const productHandle = this.dataset.productHandle;
        const productId = this.dataset.productId;

        if (!productHandle) return;

        // Check if same product is already selected
        const currentHandle = productCard.getAttribute('data-product-handle');
        if (currentHandle === productHandle && this.classList.contains('is-selected')) {
          return; // Same product already selected, no need to update
        }

        // Update selected state
        const allSwatches = productCard.querySelectorAll('.product-card__color-swatches .product-card__swatch');
        allSwatches.forEach(s => s.classList.remove('is-selected'));
        this.classList.add('is-selected');

        // Scroll clicked swatch to center
        //this.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        // Scroll clicked swatch to center within the swatch container only
        // The actual scrollable container is .h-stack inside .product-card__color-swatches
        const swatchContainer = productCard.querySelector('.product-card__color-swatches .h-stack');
        if (swatchContainer) {
          // Use requestAnimationFrame to ensure DOM is updated before calculating positions
          requestAnimationFrame(() => {
            const containerRect = swatchContainer.getBoundingClientRect();
            const swatchRect = this.getBoundingClientRect();
            const scrollLeft = swatchContainer.scrollLeft;

            // Calculate the swatch's position relative to the container's scroll position
            const swatchOffsetLeft = swatchRect.left - containerRect.left + scrollLeft;
            const swatchWidth = swatchRect.width;
            const containerWidth = containerRect.width;
            const maxScroll = swatchContainer.scrollWidth - containerWidth;

            // Check if this is the last swatch or near the end
            const allSwatches = Array.from(productCard.querySelectorAll('.product-card__color-swatches .product-card__swatch'));
            const isLastSwatch = allSwatches.indexOf(this) === allSwatches.length - 1;
            const swatchRightEdge = swatchOffsetLeft + swatchWidth;
            const containerRightEdge = maxScroll + containerWidth;
            const isNearEnd = swatchRightEdge > containerRightEdge - swatchWidth;

            let targetScrollLeft;

            if (isLastSwatch || isNearEnd) {
              // For last swatch or near end, scroll to show it fully (align to right edge)
              targetScrollLeft = swatchOffsetLeft + swatchWidth - containerWidth;
            } else {
              // For other swatches, center them
              targetScrollLeft = swatchOffsetLeft - (containerWidth / 2) + (swatchWidth / 2);
            }

            // Ensure we don't scroll beyond the container bounds
            const clampedScroll = Math.max(0, Math.min(targetScrollLeft, maxScroll));

            // Scroll the container
            if (swatchContainer.scrollTo) {
              swatchContainer.scrollTo({
                left: clampedScroll + 1,
                behavior: 'smooth'
              });
            } else {
              // Fallback for older browsers
              swatchContainer.scrollLeft = clampedScroll + 1;
            }
          });
        }

        // Show full card loader
        const fullLoader = productCard.querySelector('.product-card__full-loader');
        if (fullLoader) {
          fullLoader.classList.add('is-active');
        }

        // Fetch product data
        try {
          let productData;
          if (window.productDataCache[productHandle]) {
            productData = window.productDataCache[productHandle];
          } else {
            const response = await fetch(`/products/${productHandle}.js`);
            if (!response.ok) throw new Error('Failed to fetch product');
            productData = await response.json();
            window.productDataCache[productHandle] = productData;
          }

          // Update product card data attributes
          productCard.setAttribute('data-product-handle', productHandle);
          productCard.setAttribute('data-product-id', productId || productData.id || '');

          // Update product URL
          const productUrl = `/products/${productHandle}`;
          const fullProductUrl = window.location.origin + productUrl;
          const urlElements = productCard.querySelectorAll('[data-product-url]');
          urlElements.forEach(el => {
            if (el.tagName === 'A') {
              el.href = productUrl;
            } else {
              el.setAttribute('data-product-url', fullProductUrl);
            }
          });

          // Replace wishlist button: clone (keeps Swym UI), update data, re-init so correct product is added
          const wishlistBtn = productCard.querySelector('.swym-button[data-swaction="addToWishlist"]');
          if (wishlistBtn && productData) {
            const variant = productData.variants && productData.variants.length > 0
              ? (productData.variants.find(v => v && v.available) || productData.variants[0])
              : null;
            const variantId = variant && variant.id ? variant.id : (productData.id || '');
            const productIdStr = String(productData.id || productId || '');
            const clone = wishlistBtn.cloneNode(true);
            clone.setAttribute('data-product-id', productIdStr);
            clone.setAttribute('data-variant-id', String(variantId));
            clone.setAttribute('data-product-url', fullProductUrl);
            clone.className = clone.className.replace(/product_\d+/g, 'product_' + productIdStr);
            clone.classList.remove('swym-loaded');
            wishlistBtn.parentNode.replaceChild(clone, wishlistBtn);
            setTimeout(function () {
              document.dispatchEvent(new CustomEvent('swym:collections-loaded', { bubbles: true }));
              if (window._swat) {
                if (typeof window._swat.initializeActionButtons === 'function') {
                  try { window._swat.initializeActionButtons('product-list'); } catch (e) { }
                }
                if (typeof window._swat.collectionUpdate === 'function') {
                  try { window._swat.collectionUpdate(); } catch (e) { }
                }
              }
            }, 300);
          }

          // Update product title (split by ' - ' like Liquid: main title span + subtitle span)
          const titleElement = productCard.querySelector('[data-product-title]');
          if (titleElement && productData.title) {
            const titleParts = productData.title.split(' - ');
            const mainTitle = titleParts[0] || '';
            const subtitle = titleParts.length > 1 ? titleParts[1] : '';
            let mainSpan = titleElement.querySelector('.product-card__title-main');
            let subtitleSpan = titleElement.querySelector('.product-card__subtitle');
            titleElement.childNodes.forEach(n => n.remove());
            if (!mainSpan) {
              mainSpan = document.createElement('span');
              mainSpan.className = 'product-card__title-main';
            }
            mainSpan.textContent = mainTitle;
            titleElement.appendChild(mainSpan);
            if (subtitle) {
              if (!subtitleSpan) {
                subtitleSpan = document.createElement('span');
                subtitleSpan.className = 'product-card__subtitle';
              }
              subtitleSpan.textContent = subtitle;
              titleElement.appendChild(subtitleSpan);
            }
          }

          // Update badges (on sale badge with percentage/savings)
          const figure = productCard.querySelector('.product-card__figure');
          if (figure) {
            const badgeWishlist = figure.querySelector('.badge_wishlist');
            let badgeList = figure.querySelector('badge-list');

            // Create badge-list if it doesn't exist - append inside .badge_wishlist (same as on load)
            if (!badgeList) {
              badgeList = document.createElement('badge-list');
              badgeList.className = 'badge-list badge-list--vertical';
              if (badgeWishlist) {
                badgeWishlist.appendChild(badgeList);
              } else {
                figure.insertBefore(badgeList, figure.firstChild);
              }
            }

            // Check if product is on sale (for card context, check product.compare_at_price > product.price)
            const isOnSale = productData.compare_at_price && parseFloat(productData.compare_at_price) > parseFloat(productData.price);

            // Remove existing on-sale-badge
            const existingSaleBadge = badgeList.querySelector('on-sale-badge');
            if (existingSaleBadge) {
              existingSaleBadge.remove();
            }

            // Add on-sale-badge if product is on sale
            if (isOnSale) {
              const saleBadge = document.createElement('on-sale-badge');
              saleBadge.className = 'badge badge--on-sale';

              // Check if compare_at_price varies or variant has no compare_at_price
              const compareAtPriceVaries = productData.variants && productData.variants.some(v =>
                v && v.compare_at_price && parseFloat(v.compare_at_price) !== parseFloat(productData.compare_at_price)
              );

              // Get first variant with compare_at_price for calculation
              const variantWithComparePrice = productData.variants && productData.variants.find(v =>
                v && v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price)
              );

              if (compareAtPriceVaries || !variantWithComparePrice) {
                // Just show "on sale" badge
                saleBadge.textContent = getTranslation('on_sale_badge', 'On sale');
              } else {
                // Calculate savings based on discountMode setting
                const discountMode = getSetting('discountMode', 'saving');
                const comparePrice = parseFloat(variantWithComparePrice.compare_at_price);
                const salePrice = parseFloat(variantWithComparePrice.price);
                const savings = comparePrice - salePrice;

                let savingsText = '';
                if (discountMode === 'percentage') {
                  const percentage = Math.round((savings / comparePrice) * 100);
                  savingsText = percentage + '%';
                } else {
                  // Format as money
                  const moneyFormat = window.themeVariables?.settings?.moneyFormat || getSetting('moneyFormat', '${{amount}}');
                  const formattedSavings = Shopify.formatMoney ? Shopify.formatMoney(savings * 100, moneyFormat) : (savings).toFixed(2);
                  savingsText = removeTrailingZeros(formattedSavings);
                }

                // Use discount_badge_html translation
                const discountBadgeTemplate = getTranslation('discountBadgeHtml', 'Save {{ savings }}');
                saleBadge.innerHTML = discountBadgeTemplate.replace('{{ savings }}', savingsText);
              }

              badgeList.appendChild(saleBadge);
            }

            // Update sold-out badge
            const existingSoldOutBadge = badgeList.querySelector('sold-out-badge');
            const isAvailable = productData.available !== false && (
              productData.available === true ||
              (productData.variants && productData.variants.some(v => v && v.available))
            );

            if (!isAvailable && !existingSoldOutBadge) {
              // Add sold out badge if product is unavailable
              const soldOutBadge = document.createElement('sold-out-badge');
              soldOutBadge.className = 'badge badge--sold-out';
              soldOutBadge.textContent = getTranslation('soldOutBadge', 'Sold out');
              badgeList.appendChild(soldOutBadge);
            } else if (isAvailable && existingSoldOutBadge) {
              // Remove sold out badge if product is available
              existingSoldOutBadge.remove();
            }
          }

          // Update Judge.me widget when product changes
          const judgeMeWidget = productCard.querySelector('[data-judge-me-widget]');
          if (judgeMeWidget) {
            // Preserve original widget structure to maintain format
            const originalClasses = judgeMeWidget.className;
            const originalStyle = judgeMeWidget.getAttribute('style');
            const originalAutoInstall = judgeMeWidget.getAttribute('data-auto-install');
            const originalInnerHTML = judgeMeWidget.innerHTML;

            // Detect if original badge uses rating format (e.g., "5.0") - check for rating indicators
            const hasRatingFormat = originalInnerHTML.includes('jdgm-prev-rating') ||
              originalInnerHTML.includes('jdgm-prev-rating-text') ||
              originalInnerHTML.includes('jdgm-star') ||
              (originalInnerHTML.match(/[\d]+\.[\d]+/) && !originalInnerHTML.match(/[\d]+\s+(reviews?|ratings?)/i));

            // Update product ID first
            judgeMeWidget.setAttribute('data-id', productId || productData.id || '');
            judgeMeWidget.setAttribute('data-product-id', productId || productData.id || '');

            // If original has rating format, preserve the structure and just update IDs
            // Judge.me will update the rating value but maintain the format
            if (hasRatingFormat) {
              // Preserve the original HTML structure - just update product IDs in the HTML
              let updatedHTML = originalInnerHTML;

              // Update data-id and data-product-id in the HTML string
              updatedHTML = updatedHTML.replace(
                /data-id=['"][^'"]*['"]/g,
                `data-id="${productId || productData.id || ''}"`
              );
              updatedHTML = updatedHTML.replace(
                /data-product-id=['"][^'"]*['"]/g,
                `data-product-id="${productId || productData.id || ''}"`
              );

              // Update the innerHTML to preserve rating format structure
              judgeMeWidget.innerHTML = updatedHTML;

              // Trigger Judge.me to update (if it has an update method)
              if (window.judgeme && typeof window.judgeme.badge === 'function') {
                try {
                  window.judgeme.badge(judgeMeWidget);
                } catch (e) {
                  // Ignore errors
                }
              }
            } else {
              // Original doesn't have rating format, try to find a badge with rating format
              try {
                let badgeElement = null;
                let badgeHtml = null;

                // First, try to find another product card on the same page with this product
                const allProductCards = document.querySelectorAll('[data-product-card]');
                for (const card of allProductCards) {
                  const cardHandle = card.getAttribute('data-product-handle') || card.getAttribute('handle');
                  if (cardHandle === productHandle && card !== productCard) {
                    const cardBadge = card.querySelector('[data-judge-me-widget]');
                    if (cardBadge && cardBadge.innerHTML.trim()) {
                      const cardBadgeHTML = cardBadge.innerHTML;
                      const cardHasRating = cardBadgeHTML.includes('jdgm-prev-rating') ||
                        cardBadgeHTML.includes('jdgm-prev-rating-text') ||
                        cardBadgeHTML.includes('jdgm-star') ||
                        (cardBadgeHTML.match(/[\d]+\.[\d]+/) && !cardBadgeHTML.match(/[\d]+\s+(reviews?|ratings?)/i));

                      if (cardHasRating) {
                        badgeElement = cardBadge;
                        break;
                      }
                    }
                  }
                }

                // If found on page, clone it directly (preserves exact format)
                if (badgeElement) {
                  const clonedBadge = badgeElement.cloneNode(true);
                  clonedBadge.setAttribute('data-id', productId || productData.id || '');
                  clonedBadge.setAttribute('data-product-id', productId || productData.id || '');
                  clonedBadge.className = originalClasses;
                  if (originalStyle) {
                    clonedBadge.setAttribute('style', originalStyle);
                  }
                  if (originalAutoInstall !== null) {
                    clonedBadge.setAttribute('data-auto-install', originalAutoInstall);
                  }
                  clonedBadge.setAttribute('data-judge-me-widget', '');

                  // Replace the widget with cloned one
                  judgeMeWidget.replaceWith(clonedBadge);
                } else {
                  // Try fetching from collection page
                  const currentUrl = window.location.pathname;
                  if (currentUrl.includes('/collections/')) {
                    const collectionResponse = await fetch(currentUrl);
                    if (collectionResponse.ok) {
                      const collectionHtml = await collectionResponse.text();
                      const parser = new DOMParser();
                      const doc = parser.parseFromString(collectionHtml, 'text/html');

                      // Find product card with matching handle
                      const productCardOnPage = doc.querySelector(`[data-product-handle="${productHandle}"], [handle="${productHandle}"]`);
                      if (productCardOnPage) {
                        const badgeOnPage = productCardOnPage.querySelector('[data-judge-me-widget]');
                        if (badgeOnPage && badgeOnPage.innerHTML.trim()) {
                          badgeHtml = badgeOnPage.innerHTML;

                          // Check if fetched badge has rating format
                          const fetchedHasRating = badgeHtml.includes('jdgm-prev-rating') ||
                            badgeHtml.includes('jdgm-prev-rating-text') ||
                            badgeHtml.includes('jdgm-star') ||
                            (badgeHtml.match(/[\d]+\.[\d]+/) && !badgeHtml.match(/[\d]+\s+(reviews?|ratings?)/i));

                          // If fetched badge doesn't have rating format, look for one that does
                          if (!fetchedHasRating) {
                            const allBadgesOnPage = doc.querySelectorAll('[data-judge-me-widget]');
                            for (const otherBadge of allBadgesOnPage) {
                              const otherBadgeHTML = otherBadge.innerHTML;
                              const otherHasRating = otherBadgeHTML.includes('jdgm-prev-rating') ||
                                otherBadgeHTML.includes('jdgm-prev-rating-text') ||
                                otherBadgeHTML.includes('jdgm-star') ||
                                (otherBadgeHTML.match(/[\d]+\.[\d]+/) && !otherBadgeHTML.match(/[\d]+\s+(reviews?|ratings?)/i));
                              if (otherHasRating) {
                                badgeHtml = otherBadgeHTML.replace(
                                  /data-id=['"][^'"]*['"]/g,
                                  `data-id="${productId || productData.id || ''}"`
                                ).replace(
                                  /data-product-id=['"][^'"]*['"]/g,
                                  `data-product-id="${productId || productData.id || ''}"`
                                );
                                break;
                              }
                            }
                          } else {
                            // Update product IDs in the fetched badge HTML
                            badgeHtml = badgeHtml.replace(
                              /data-id=['"][^'"]*['"]/g,
                              `data-id="${productId || productData.id || ''}"`
                            ).replace(
                              /data-product-id=['"][^'"]*['"]/g,
                              `data-product-id="${productId || productData.id || ''}"`
                            );
                          }
                        }
                      }
                    }
                  }

                  // If we got badge HTML, use it
                  if (badgeHtml) {
                    judgeMeWidget.innerHTML = badgeHtml;
                    judgeMeWidget.className = originalClasses;
                    if (originalStyle) {
                      judgeMeWidget.setAttribute('style', originalStyle);
                    }
                    if (originalAutoInstall !== null) {
                      judgeMeWidget.setAttribute('data-auto-install', originalAutoInstall);
                    }
                  }
                }
              } catch (e) {
                //console.log('Could not fetch Judge.me badge:', e);
              }
            }
          }

          // Update price - format from productData to ensure correct price for this specific product
          // This should always run regardless of rating fetch status
          const priceElement = productCard.querySelector('[data-product-price]');
          if (priceElement) {
            // Determine text class by checking existing price element structure
            const existingPriceList = priceElement.querySelector('price-list');
            let baseTextClass = '';
            if (existingPriceList) {
              const existingSalePrice = existingPriceList.querySelector('sale-price');
              if (existingSalePrice && existingSalePrice.classList.contains('h6')) {
                baseTextClass = 'h6 ';
              }
            }

            // Use productData to format price correctly (ensures we get the right price for this product)
            const currencyCodeEnabled = window.themeVariables?.settings?.currencyCodeEnabled || false;
            const moneyFormat = currencyCodeEnabled
              ? (window.themeVariables?.settings?.moneyWithCurrencyFormat || '{{amount}} {{currency}}')
              : (window.themeVariables?.settings?.moneyFormat || '{{amount}}');

            const formatPrice = (priceInCents) => {
              // Try Shopify.formatMoney first
              if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
                try {
                  const formatted = Shopify.formatMoney(priceInCents, moneyFormat);
                  // Check if formatMoney actually worked (didn't return the template string)
                  if (formatted && !formatted.includes('{{')) {
                    return formatted;
                  }
                } catch (e) {
                  // Fall through to manual formatting
                }
              }

              // Manual formatting - handle all Shopify placeholders
              const amount = priceInCents / 100;
              const amountStr = amount.toFixed(2);
              const amountNoDecimals = Math.round(amount).toString();

              // Split amount into integer and decimal parts
              const parts = amountStr.split('.');
              const integerPart = parts[0];
              const decimalPart = parts[1];

              // Format with comma as thousand separator (e.g., 1,234.56)
              const amountWithComma = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + decimalPart;

              // Format with space separator (e.g., 1 234.56)
              const amountWithSpace = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + '.' + decimalPart;

              // Format with period as thousand and comma as decimal (e.g., 1.234,56 for European format)
              const amountEuropean = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + decimalPart;

              // Get currency code if needed
              const currency = (window.Shop && window.Shop.currency && window.Shop.currency.active) || '';

              // Detect if this is European format (comma as decimal separator)
              // For Danish/European: "{{amount_with_comma_separator}} DKK" should produce "999,00 DKK"
              // The format string pattern helps us determine this
              const isEuropeanFormat = moneyFormat.includes('{{amount_with_comma_separator}}') &&
                (moneyFormat.includes(' DKK') || moneyFormat.includes(',') ||
                  moneyFormat.match(/[A-Z]{3}/));

              // Replace all possible placeholders
              let formatted = moneyFormat;

              if (isEuropeanFormat) {
                // European format: comma as decimal separator (999,00)
                formatted = formatted
                  .replace(/\{\{amount_with_comma_separator\}\}/g, amountEuropean)
                  .replace(/\{\{amount_with_space_separator\}\}/g, amountWithSpace)
                  .replace(/\{\{amount_no_decimals\}\}/g, amountNoDecimals)
                  .replace(/\{\{amount\}\}/g, amountEuropean)
                  .replace(/\{\{currency\}\}/g, currency);
              } else {
                // US format: period as decimal separator (999.00)
                formatted = formatted
                  .replace(/\{\{amount_with_comma_separator\}\}/g, amountWithComma)
                  .replace(/\{\{amount_with_space_separator\}\}/g, amountWithSpace)
                  .replace(/\{\{amount_no_decimals\}\}/g, amountNoDecimals)
                  .replace(/\{\{amount\}\}/g, amountStr)
                  .replace(/\{\{currency\}\}/g, currency);
              }

              return formatted;
            };

            if (productData.variants && productData.variants.length > 0) {
              const variant = productData.variants.find(v => v && v.available) || productData.variants[0];
              if (variant && variant.price !== undefined) {
                const price = removeTrailingZeros(formatPrice(variant.price));
                const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
                const comparePrice = isOnSale ? removeTrailingZeros(formatPrice(variant.compare_at_price)) : null;

                const salePriceClass = isOnSale ? `${baseTextClass}text-on-sale` : `${baseTextClass}text-subdued`;
                const comparePriceClass = `${baseTextClass}text-subdued line-through`;

                let priceHtml = '<price-list class="price-list">';
                priceHtml += `<sale-price class="${salePriceClass}"><span class="sr-only">${isOnSale ? 'Sale price' : 'Price'}</span>${price}</sale-price>`;
                if (comparePrice) {
                  priceHtml += `<compare-at-price class="${comparePriceClass}"><span class="sr-only">Regular price</span>${comparePrice}</compare-at-price>`;
                }
                priceHtml += '</price-list>';
                priceElement.innerHTML = priceHtml;
              }
            } else if (productData.price !== undefined) {
              const price = removeTrailingZeros(formatPrice(productData.price));
              const isOnSale = productData.compare_at_price && productData.compare_at_price > productData.price;
              const comparePrice = isOnSale ? removeTrailingZeros(formatPrice(productData.compare_at_price)) : null;

              const salePriceClass = isOnSale ? `${baseTextClass}text-on-sale` : `${baseTextClass}text-subdued`;
              const comparePriceClass = `${baseTextClass}text-subdued line-through`;

              let priceHtml = '<price-list class="price-list">';
              priceHtml += `<sale-price class="${salePriceClass}"><span class="sr-only">${isOnSale ? 'Sale price' : 'Price'}</span>${price}</sale-price>`;
              if (comparePrice) {
                priceHtml += `<compare-at-price class="${comparePriceClass}"><span class="sr-only">Regular price</span>${comparePrice}</compare-at-price>`;
              }
              priceHtml += '</price-list>';
              priceElement.innerHTML = priceHtml;
            }
          }

          // Update rating - use product metafields
          const infoSection = productCard.querySelector('.product-card__info');
          if (infoSection) {
            const showEmpty = getSetting('showProductRatingIfEmpty', false);
            const displayMode = getSetting('productRatingMode', 'rating');

            // Get rating from product metafields (if available in JSON response)
            // Note: Product JSON might not include metafields, so we'll fetch product HTML as fallback
            let ratingValue = null;
            let ratingCount = null;
            let ratingMax = 5;

            if (productData.metafields && productData.metafields.reviews && productData.metafields.reviews.rating) {
              ratingValue = productData.metafields.reviews.rating.value?.rating;
              ratingCount = productData.metafields.reviews.rating_count?.value;
              ratingMax = productData.metafields.reviews.rating.value?.scale_max || 5;
            }

            // If no rating data and show_empty is false, hide rating
            if (!ratingValue && !showEmpty) {
              const existingRating = infoSection.querySelector('.rating-badge');
              if (existingRating) {
                existingRating.remove();
              }
            } else {
              // Fetch product HTML to get properly rendered rating
              try {
                const productPageResponse = await fetch(`/products/${productHandle}`);
                if (productPageResponse.ok) {
                  const productHtml = await productPageResponse.text();
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(productHtml, 'text/html');

                  // Try to find rating in the product page
                  const ratingFromPage = doc.querySelector('.rating-badge');
                  if (ratingFromPage) {
                    const existingRating = infoSection.querySelector('.rating-badge');
                    if (existingRating) {
                      existingRating.replaceWith(ratingFromPage.cloneNode(true));
                    } else {
                      // Insert before price element if it exists
                      const priceElement = infoSection.querySelector('[data-product-price]');
                      if (priceElement) {
                        priceElement.before(ratingFromPage.cloneNode(true));
                      } else {
                        // Fallback: insert before add to cart button if price not found
                        const addToCartBtn = infoSection.querySelector('.product-card__add-to-cart, .product-card__add-to-cart-button');
                        if (addToCartBtn) {
                          addToCartBtn.before(ratingFromPage.cloneNode(true));
                        } else {
                          infoSection.appendChild(ratingFromPage.cloneNode(true));
                        }
                      }
                    }
                  } else if (!showEmpty) {
                    // Hide rating if not found and show_empty is false
                    const existingRating = infoSection.querySelector('.rating-badge');
                    if (existingRating) {
                      existingRating.remove();
                    }
                  }
                }
              } catch (e) {
                //console.log('Could not fetch product page:', e);
              }
            }
          }

          // Update product image
          const imageElement = productCard.querySelector('[data-product-image]');
          if (imageElement && productData.featured_image) {
            const img = productData.featured_image;
            const srcset = `${img} 200w, ${img} 300w, ${img} 400w, ${img} 500w, ${img} 600w, ${img} 700w, ${img} 800w, ${img} 1000w, ${img} 1200w`;

            // Wait for image to load before hiding loader
            const newImage = new Image();
            newImage.onload = () => {
              imageElement.src = img;
              imageElement.srcset = srcset;
              imageElement.alt = productData.title || '';
              imageElement.style.opacity = '1';

              // Hide full card loader after image loads
              const fullLoader = productCard.querySelector('.product-card__full-loader');
              if (fullLoader) {
                fullLoader.classList.remove('is-active');
              }
              document.dispatchEvent(new CustomEvent('swym:collections-loaded', { bubbles: true }));
              if (window._swat && typeof window._swat.collectionUpdate === 'function') {
                try { window._swat.collectionUpdate(); } catch (e) { }
              }
            };
            newImage.onerror = () => {
              // Hide loader even on error
              const fullLoader = productCard.querySelector('.product-card__full-loader');
              if (fullLoader) {
                fullLoader.classList.remove('is-active');
              }
              imageElement.style.opacity = '1';
            };
            newImage.src = img;
          } else {
            // Hide loader if no image
            const fullLoader = productCard.querySelector('.product-card__full-loader');
            if (fullLoader) {
              fullLoader.classList.remove('is-active');
            }
            if (imageElement) {
              imageElement.style.opacity = '1';
            }
          }

          // Update secondary/hover media (image or video)
          let secondaryImageElement = productCard.querySelector('[data-product-secondary-image]');
          let secondaryVideoElement = productCard.querySelector('[data-product-secondary-video]');
          const mediaLink = productCard.querySelector('.product-card__media');
          const sizes = productCard.querySelector('[data-product-image]')?.getAttribute('sizes') || '';

          // Remove existing secondary media
          if (secondaryImageElement) {
            secondaryImageElement.remove();
          }
          if (secondaryVideoElement) {
            secondaryVideoElement.remove();
          }

          // Check if product has media array (for video support)
          if (productData.media && productData.media.length > 1) {
            const nextMedia = productData.media[1];
            const mediaType = nextMedia.media_type || 'image';

            if (mediaType === 'video' || mediaType === 'external_video') {
              // Create video-media element
              if (mediaLink) {
                const videoWrapper = document.createElement('div');
                videoWrapper.setAttribute('data-product-secondary-video', '');

                const videoMedia = document.createElement('video-media');
                videoMedia.className = 'product-card__image product-card__image--secondary';
                videoMedia.setAttribute('type', mediaType);
                videoMedia.setAttribute('autoplay', '');
                if (nextMedia.host) {
                  videoMedia.setAttribute('host', nextMedia.host);
                }
                if (nextMedia.aspect_ratio) {
                  videoMedia.style.setProperty('--aspect-ratio', nextMedia.aspect_ratio);
                }
                videoMedia.setAttribute('aria-hidden', 'true');

                // Add preview image
                if (nextMedia.preview && nextMedia.preview.src) {
                  const previewImg = document.createElement('img');
                  previewImg.src = nextMedia.preview.src;
                  previewImg.srcset = `${nextMedia.preview.src} 200w, ${nextMedia.preview.src} 300w, ${nextMedia.preview.src} 400w, ${nextMedia.preview.src} 500w, ${nextMedia.preview.src} 600w, ${nextMedia.preview.src} 700w, ${nextMedia.preview.src} 800w, ${nextMedia.preview.src} 1000w, ${nextMedia.preview.src} 1200w, ${nextMedia.preview.src} 1400w, ${nextMedia.preview.src} 1600w, ${nextMedia.preview.src} 1800w`;
                  previewImg.loading = 'lazy';
                  previewImg.fetchPriority = 'low';
                  previewImg.draggable = false;
                  previewImg.sizes = sizes;
                  videoMedia.appendChild(previewImg);
                }

                // Add video element or iframe template
                if (mediaType === 'video' && nextMedia.sources) {
                  const video = document.createElement('video');
                  video.setAttribute('playsinline', '');
                  video.setAttribute('muted', '');
                  video.setAttribute('loop', '');
                  video.setAttribute('autoplay', '');
                  video.setAttribute('preload', 'auto');
                  nextMedia.sources.forEach(source => {
                    const sourceEl = document.createElement('source');
                    sourceEl.src = source.url;
                    sourceEl.type = source.mime_type;
                    video.appendChild(sourceEl);
                  });
                  videoMedia.appendChild(video);
                } else if (mediaType === 'external_video' && nextMedia.host) {
                  const template = document.createElement('template');
                  const iframe = document.createElement('iframe');
                  iframe.setAttribute('allowfullscreen', 'allowfullscreen');
                  iframe.setAttribute('allow', 'autoplay; encrypted-media');

                  if (nextMedia.host === 'youtube' && nextMedia.id) {
                    iframe.src = `https://www.youtube.com/embed/${nextMedia.id}?playsinline=1&autoplay=1&mute=1&loop=1&playlist=${nextMedia.id}&enablejsapi=1&rel=0&modestbranding=1&origin=${encodeURIComponent(window.location.origin)}`;
                  } else if (nextMedia.host === 'vimeo' && nextMedia.id) {
                    iframe.src = `https://player.vimeo.com/video/${nextMedia.id}?autoplay=1&loop=1&muted=1&background=1&transparent=0&responsive=1&portrait=0&title=0&byline=0`;
                  }

                  template.appendChild(iframe);
                  videoMedia.appendChild(template);
                }

                videoWrapper.appendChild(videoMedia);
                mediaLink.appendChild(videoWrapper);

                // Set up video playback on hover
                const figure = productCard.querySelector('.product-card__figure');
                if (figure) {
                  // Wait for video-media to be fully connected
                  const initVideoPlayback = () => {
                    const playVideo = () => {
                      // Try video-media's play method first
                      if (videoMedia && typeof videoMedia.play === 'function') {
                        videoMedia.play().catch(() => { });
                      }
                      // Also try direct video element as fallback
                      const videoEl = videoMedia.querySelector('video');
                      if (videoEl && videoEl.paused) {
                        videoEl.play().catch(() => { });
                      }
                    };

                    const pauseVideo = () => {
                      // Try video-media's pause method first
                      if (videoMedia && typeof videoMedia.pause === 'function') {
                        videoMedia.pause();
                      }
                      // Also try direct video element as fallback
                      const videoEl = videoMedia.querySelector('video');
                      if (videoEl && !videoEl.paused) {
                        videoEl.pause();
                      }
                    };

                    // Play when figure is hovered (video becomes visible)
                    figure.addEventListener('mouseenter', () => {
                      // Small delay to ensure CSS transition has started
                      setTimeout(playVideo, 200);
                    });

                    // Pause when mouse leaves
                    figure.addEventListener('mouseleave', pauseVideo);

                    // Also listen for when video becomes visible via CSS transition
                    const checkAndPlay = () => {
                      const computedStyle = window.getComputedStyle(videoMedia);
                      if (parseFloat(computedStyle.opacity) > 0.5) {
                        playVideo();
                      }
                    };

                    // Use MutationObserver to watch for style changes
                    const styleObserver = new MutationObserver(() => {
                      checkAndPlay();
                    });

                    styleObserver.observe(videoMedia, {
                      attributes: true,
                      attributeFilter: ['style', 'class'],
                      attributeOldValue: false
                    });

                    // Also listen for transition end
                    videoMedia.addEventListener('transitionend', (e) => {
                      if (e.propertyName === 'opacity') {
                        checkAndPlay();
                      }
                    });
                  };

                  // Initialize after a short delay to ensure custom element is ready
                  if (customElements.get('video-media')) {
                    initVideoPlayback();
                  } else {
                    // Wait for custom element to be defined
                    customElements.whenDefined('video-media').then(() => {
                      initVideoPlayback();
                    });
                  }
                }
              }
            } else if (productData.images && productData.images.length > 1) {
              // Create secondary image
              if (mediaLink) {
                const nextMedia = productData.images[1];
                secondaryImageElement = document.createElement('img');
                secondaryImageElement.className = 'product-card__image product-card__image--secondary';
                secondaryImageElement.src = nextMedia;
                secondaryImageElement.srcset = `${nextMedia} 200w, ${nextMedia} 300w, ${nextMedia} 400w, ${nextMedia} 500w, ${nextMedia} 600w, ${nextMedia} 700w, ${nextMedia} 800w, ${nextMedia} 1000w, ${nextMedia} 1200w, ${nextMedia} 1400w, ${nextMedia} 1600w, ${nextMedia} 1800w`;
                secondaryImageElement.loading = 'lazy';
                secondaryImageElement.fetchPriority = 'low';
                secondaryImageElement.draggable = false;
                secondaryImageElement.setAttribute('aria-hidden', 'true');
                secondaryImageElement.setAttribute('data-product-secondary-image', '');
                secondaryImageElement.sizes = sizes;
                mediaLink.appendChild(secondaryImageElement);
              }
            }
          } else if (productData.images && productData.images.length > 1) {
            // Fallback to images array if media array not available
            if (mediaLink) {
              const nextMedia = productData.images[1];
              secondaryImageElement = document.createElement('img');
              secondaryImageElement.className = 'product-card__image product-card__image--secondary';
              secondaryImageElement.src = nextMedia;
              secondaryImageElement.srcset = `${nextMedia} 200w, ${nextMedia} 300w, ${nextMedia} 400w, ${nextMedia} 500w, ${nextMedia} 600w, ${nextMedia} 700w, ${nextMedia} 800w, ${nextMedia} 1000w, ${nextMedia} 1200w, ${nextMedia} 1400w, ${nextMedia} 1600w, ${nextMedia} 1800w`;
              secondaryImageElement.loading = 'lazy';
              secondaryImageElement.fetchPriority = 'low';
              secondaryImageElement.draggable = false;
              secondaryImageElement.setAttribute('aria-hidden', 'true');
              secondaryImageElement.setAttribute('data-product-secondary-image', '');
              secondaryImageElement.sizes = sizes;
              mediaLink.appendChild(secondaryImageElement);
            }
          }

          // Update swatch image for selected swatch
          const selectedSwatch = productCard.querySelector('.product-card__swatch.is-selected');
          if (selectedSwatch && productData.featured_image) {
            const swatchImage = selectedSwatch.querySelector('.product-card__swatch-image');
            if (swatchImage) {
              swatchImage.src = productData.featured_image;
              swatchImage.srcset = `${productData.featured_image} 60w`;
              swatchImage.alt = productData.title || '';
            }
          }

          // Price is updated in the rating fetch block above to reuse the same product page fetch

          // Check product availability
          const isAvailable = productData.available !== false && (
            productData.available === true ||
            (productData.variants && productData.variants.length > 0 && productData.variants.some(v => v && v.available))
          );

          const is_new_preorder = productData.tags.includes('new-preorder');
          const variantCount = productData.variants ? productData.variants.length : 0;
          const hasSellingPlans = productData.selling_plan_groups && productData.selling_plan_groups.length > 0;
          const supportsDirectAdd = isAvailable && !is_new_preorder && variantCount === 1 && !hasSellingPlans;

          // Update add to cart button (opens quick buy modal) based on availability
          const addToCartForm = productCard.querySelector('product-form.product-card__add-to-cart');
          const addToCartButton = productCard.querySelector('.product-card__add-to-cart-button--modal');
          const addToCartSubmitButton = productCard.querySelector('.product-card__add-to-cart-btn');
          const soldOutButton = productCard.querySelector('.product-card__sold-out-button');
          const quickBuyModal = productCard.querySelector('quick-buy-modal');
          const preOrderButton = productCard.querySelector('.product-card__pre-order-button');
          const variantIdInput = productCard.querySelector('.product-card-variant-id');

          if (supportsDirectAdd) {
            const variant = productData.variants[0];
            if (variantIdInput && variant) {
              variantIdInput.value = variant.id;
            }
            if (addToCartForm) {
              addToCartForm.style.display = 'block';
              addToCartForm.setAttribute('data-product-handle', productHandle);
              addToCartForm.setAttribute('data-product-available', 'true');
            }
            if (addToCartSubmitButton) {
              addToCartSubmitButton.style.display = 'block';
            }
            if (addToCartButton) {
              addToCartButton.style.display = 'none';
            }
          } else {
            if (addToCartForm) {
              addToCartForm.style.display = 'none';
            }
            if (addToCartSubmitButton) {
              addToCartSubmitButton.style.display = 'none';
            }
          }

          if (isAvailable) {
            if (soldOutButton) {
              soldOutButton.style.display = 'none';
            }
            if (preOrderButton) {
              preOrderButton.style.display = is_new_preorder ? 'block' : 'none';
            }
            if (addToCartButton && !supportsDirectAdd && !is_new_preorder) {
              addToCartButton.style.display = 'block';
              addToCartButton.setAttribute('data-product-handle', productHandle);
              addToCartButton.setAttribute('data-product-available', 'true');
              const addToCartText = getTranslation('addToCartButton', 'Add to cart');
              addToCartButton.textContent = addToCartText;
            } else if (addToCartButton) {
              addToCartButton.style.display = 'none';
            }
          } else {
            if (addToCartForm) {
              addToCartForm.style.display = 'none';
            }
            if (addToCartButton) {
              addToCartButton.style.display = 'none';
            }

            if (preOrderButton) {
              preOrderButton.style.display = is_new_preorder ? 'block' : 'none';
            }

            // Show sold out button
            if (is_new_preorder) {
              if (soldOutButton) {
                soldOutButton.style.display = 'none';
              }
            } else if (soldOutButton) {
              soldOutButton.style.display = 'block';
              soldOutButton.setAttribute('data-product-available', 'false');
            } else {
              if (!soldOutButton) {
                // Create sold out button if doesn't exist
                const soldOutText = getTranslation('soldOutBadge', 'Sold out');
                const soldOutHtml = `
                <button type="button" class="button button--primary button--full product-card__sold-out-button" disabled data-product-available="false">
                  ${soldOutText}
                </button>
              `;
                const buttonContainer = productCard.querySelector('.product-card__info');
                if (buttonContainer) {
                  buttonContainer.insertAdjacentHTML('beforeend', soldOutHtml);
                }
              } else if (!preOrderButton && is_new_preorder) {
                const preorderText = getTranslation('preOrderButton', 'Pre-order');
                const preorderHtml = `
                <a  href="/products/${productHandle}" class="button button--primary button--full product-card__pre-order-button" disabled data-product-available="true">
                  ${preorderText}
                </a>
              `;
                const buttonContainer = productCard.querySelector('.product-card__info');
                if (buttonContainer) {
                  buttonContainer.insertAdjacentHTML('beforeend', preorderHtml);
                }
              }
            }
          }
          if (quickBuyModal) {
            const variant = productData.variants && productData.variants.length > 0
              ? (productData.variants.find(v => v && v.available) || productData.variants[0])
              : null;
            const handleUrl = variant && variant.id
              ? `${productHandle}?variant=${variant.id}`
              : productHandle;
            quickBuyModal.setAttribute('handle', handleUrl);
            quickBuyModal.setAttribute('data-product-handle', productHandle);
            if (addToCartButton && addToCartButton.type === 'button') {
              addToCartButton.setAttribute('aria-controls', quickBuyModal.id);
            }
            if (preOrderButton) {
              preOrderButton.setAttribute('href', variant && variant.url ? variant.url : "/products/" + productHandle);
            }
          }
        } catch (error) {
          console.error('Error fetching product data:', error);

          // Hide full card loader on error
          const fullLoader = productCard.querySelector('.product-card__full-loader');
          if (fullLoader) {
            fullLoader.classList.remove('is-active');
          }
        }
      });
    });
  }

  // Initialize all product cards with swatches on page load
  function initializeAllSwatches() {
    const productCards = document.querySelectorAll('[data-product-card]');
    productCards.forEach(card => {
      const hasSwatches = card.querySelector('.product-card__color-swatches .product-card__swatch');
      if (hasSwatches) {
        initializeSwatches(card);
      }
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllSwatches);
  } else {
    initializeAllSwatches();
  }

  // Reinitialize Swym wishlist when AJAX content loads (filters, pagination)
  function reinitializeSwymWishlist() {
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('swym:collections-loaded', { bubbles: true }));
      if (window._swat) {
        if (typeof window._swat.initializeActionButtons === 'function') {
          try { window._swat.initializeActionButtons('product-list'); } catch (e) { }
        }
        if (typeof window._swat.collectionUpdate === 'function') {
          try { window._swat.collectionUpdate(); } catch (e) { }
        }
      }
    }, 450);
  }

  document.addEventListener('theme:loading:end', function () {
    setTimeout(initializeAllSwatches, 100);
    reinitializeSwymWishlist();
  });

  document.addEventListener('facet:update', function () {
    setTimeout(initializeAllSwatches, 200);
    reinitializeSwymWishlist();
  });

  // Function to calculate and apply promo_h2 height
  function calculateAndApplyPromoHeight() {
    // Find the first product card with collection-card-info
    const firstCardInfo = document.querySelector('.collection-card-info');

    if (firstCardInfo) {
      // Calculate the height of the first card's info section
      const cardInfoHeight = firstCardInfo.offsetHeight;

      // Apply this min-height to all promo_h2 elements
      const promoHeadings = document.querySelectorAll('.promo_h2');
      promoHeadings.forEach(function (promoHeading) {
        promoHeading.style.minHeight = cardInfoHeight + 'px';
      });
    }
  }

  // Calculate height on page load
  function initializePromoHeight() {
    // Wait for images and content to load
    setTimeout(function () {
      calculateAndApplyPromoHeight();
    }, 100);
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializePromoHeight();
    });
  } else {
    initializePromoHeight();
  }

  // Recalculate on window resize
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      calculateAndApplyPromoHeight();
    }, 250);
  });

  // Recalculate when AJAX content loads
  document.addEventListener('theme:loading:end', function () {
    setTimeout(calculateAndApplyPromoHeight, 200);
  });

  document.addEventListener('facet:update', function () {
    setTimeout(calculateAndApplyPromoHeight, 300);
  });
})();

